import cn from 'classnames';

import IconSuccess from '@dealroadshow/uikit-icon/IconSuccess';
import { CALL_FORM_STEPS } from '../../constants';
import { ICallFormStep } from '../../interfaces';

import styles from './header.module.scss';

interface IProps {
  currentStep: ICallFormStep,
}

const Header = ({ currentStep }: IProps) => {
  const steps = Object.values(CALL_FORM_STEPS);

  return (
    <div className={ styles.header }>
      { steps.map(
        (step, i) => {
          const currentStepIndex = steps.indexOf(currentStep);
          const stepCls = cn(
            styles.step,
            {
              [styles.isStepActive]: i === currentStepIndex,
              [styles.isStepCompleted]: i < currentStepIndex,
            },
          );
          return (
            <div
              key={ step.title }
              className={ stepCls }
            >
              <IconSuccess className={ styles.stepCheckIcon } />
              <span className={ styles.stepTitle }>{ step.title }</span>
              <div className={ styles.stepStripe } />
              <div className={ styles.stepCircle }>{ i + 1 }</div>
            </div>
          );
        },
      ) }
    </div>
  );
};

export default Header;
